import z from 'zod';
/**
 * Schema per ProfileAdditionalData
 * @db_table profiles_additional_data
 */
export const profileAdditionalDataSchema = z.object({
    id: z.number(),
    name: z.string(),
    label: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    organization_id: z.number().optional().nullable() // ID dell'organizzazione che ha aggiunto questo dato
});
export const profileAdditionalDataSchemaItem = profileAdditionalDataSchema.extend({
    value: z.union([z.number(), z.string()]),
});
export const profileAdditionalDataSchemaNoId = profileAdditionalDataSchema.omit({ id: true });
export const profileAdditionalDataSchemaRecord = z.object({
    additional_id: z.number(),
    value: z.union([z.number(), z.string()])
});
//# sourceMappingURL=profileAdditionalDataSchema.js.map